import { debounce } from '@/lib/lodash'
import { TransformableImage } from 'vue-advanced-cropper'

export default {
  components: {
    TransformableImage,
  },
  props: ['touchMove', 'mouseMove', 'touchResize', 'wheelResize'],
  data() {
    return {
      notificationVisible: false,
      notificationType: null,
      isCtrlPressed: false,
    }
  },
  created() {
    this.hideNotifications = debounce(() => {
      this.notificationVisible = false
    }, 1000)

    window.addEventListener('keydown', this.onKeyChange)
    window.addEventListener('keyup', this.onKeyChange)
    window.addEventListener('blur', this.resetCtrlPressed)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyChange)
    window.removeEventListener('keyup', this.onKeyChange)
    window.removeEventListener('blur', this.resetCtrlPressed)
    this.hideNotifications.cancel()
  },
  methods: {
    onKeyChange(event) {
      this.isCtrlPressed = event.ctrlKey
    },
    resetCtrlPressed() {
      this.isCtrlPressed = false
    },
    eventsFilter(nativeEvent, transforming) {
      if (
        nativeEvent.type === 'touchstart' ||
        nativeEvent.type === 'touchmove'
      ) {
        if (nativeEvent.touches.length === 1 && !transforming) {
          this.notificationVisible = true
          this.notificationType = 'touch'
          this.hideNotifications()
          return false
        } else {
          this.notificationVisible = false
        }
      } else if (nativeEvent.type === 'wheel') {
        if (!transforming && !this.isCtrlPressed) {
          this.notificationVisible = true
          this.notificationType = 'wheel'
          this.hideNotifications()
          return false
        } else {
          this.notificationVisible = false
        }
      }
      nativeEvent.preventDefault()
      nativeEvent.stopPropagation()
    },
  },
}
